import styled from "styled-components";
import { background, margin, size } from "./styled";

const Diamond = styled.div`
  text-align: center;
  transform: rotate(45deg);
  border: 1px solid black;
  ${(props) => background(props)};
  ${(props) => margin(props)}
  ${(props) => size(props)}
`;

export default Diamond;
